import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import { useShallow } from 'zustand/react/shallow';

import { openURL } from '@src/utils';
import { useRoomStore } from '@src/stores';

import { EWebinarRoutes } from '@src/constants';

const useCreateMeetingAction = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [meetingLink, setMeetingLink] = useState<string | null>(null);
  const navigate = useNavigate();

  const { roomTitle } = useRoomStore(
    useShallow((state) => ({
      roomTitle: state.roomTitle,
    }))
  );

  const isTitleEmpty = !roomTitle.trim();

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const handleOpenModal = useCallback(async () => {
    handleClose();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SFU_API_URL}/api/v1/meeting`,
        { event_title: roomTitle },
        {
          timeout: 5000,
          withCredentials: true,
        }
      );

      const { data } = response;
      const meetingLink = data?.room?.meeting_link || '';

      setMeetingLink(meetingLink);
      setIsModalOpen(true);
    } catch (error) {
      console.error('Error creating meeting:', error);
      setMeetingLink('');
    } finally {
      setIsModalOpen(true);
    }
  }, [handleClose, roomTitle]);

  const navigateToWebinar = useCallback(
    (routeType: string) => {
      if (routeType === 'create') {
        navigate(EWebinarRoutes.CREATE);
      } else if (routeType === 'register') {
        navigate(EWebinarRoutes.REGISTRATION_FORM);
      }
    },
    [navigate]
  );

  const handleScheduleInCalendar = useCallback(() => {
    openURL(`${process.env.REACT_APP_ROOT_CONFIG_URL}/o-mailo/calendar?title=${roomTitle.trim()}`, true);
    handleClose();
  }, [handleClose, roomTitle]);

  return {
    meetingLink,
    isModalOpen,
    isMenuOpen,
    anchorEl,
    isTitleEmpty,
    setIsModalOpen,
    setAnchorEl,
    handleClose,
    handleOpenModal,
    navigateToWebinar,
    handleScheduleInCalendar,
  };
};
export default useCreateMeetingAction;
